// API配置常量
export const API_CONFIG = {
  // 开发环境使用代理
  development: {
    baseUrl: '/api/demo',
    endpoints: {
      demo: '/requests/add'
    }
  },
  // 生产环境使用直接地址
  production: {
    baseUrl: '/api/website/demo',
    endpoints: {
      demo: '/requests/add'
    }
  }
}

// 获取当前环境的API配置
export const getApiConfig = () => {
  const env = process.env.NODE_ENV || 'development'
  return API_CONFIG[env as keyof typeof API_CONFIG] || API_CONFIG.development
}

// 构建完整的API URL
export const buildApiUrl = (endpoint: string) => {
  const config = getApiConfig()
  return `${config.baseUrl}${endpoint}`
}

// 具体的API地址
export const API_URLS = {
  demo: () => buildApiUrl('/requests/add')
}
